import { getImageUrlFromGoogleUserContent, styled, Image } from '@teko/ds-desktop';
import React from 'react';
import { ProductCarousel } from '../ProductCarousel/ProductCarousel.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarouselWithHeader = (_a) => {
  var _b = _a, {
    header,
    background,
    dividerColor = "rgba(255, 255, 255, 0.5)",
    style,
    tracking,
    backgroundStyle,
    backgroundPrioritize
  } = _b, productCarouselProps = __objRest(_b, [
    "header",
    "background",
    "dividerColor",
    "style",
    "tracking",
    "backgroundStyle",
    "backgroundPrioritize"
  ]);
  const { isMobile } = useDevice();
  const MOBILE_BG_WIDTH = 856, DESKTOP_BG_WIDTH = 1232;
  const backgroundUrl = getImageUrlFromGoogleUserContent(background, {
    width: isMobile ? MOBILE_BG_WIDTH : DESKTOP_BG_WIDTH
  });
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    style: __spreadValues({
      minHeight: "min-content"
    }, style)
  }, !!tracking ? tracking : {}), backgroundUrl && /* @__PURE__ */ React.createElement(Background, {
    alt: (header == null ? void 0 : header.title) || "",
    src: backgroundUrl,
    width: "100%",
    height: "100%",
    style: backgroundStyle,
    lazy: false,
    fetchpriority: backgroundPrioritize ? "high" : "auto"
  }), header && /* @__PURE__ */ React.createElement(StyledBlockHeader, __spreadProps(__spreadValues({}, header), {
    borderColor: dividerColor
  })), /* @__PURE__ */ React.createElement(StyledProductCarousel, __spreadValues({}, productCarouselProps)));
};
ProductCarouselWithHeader.displayName = "ProductCarouselWithHeader";
const Wrapper = styled.div`
  position: relative;
`;
const Background = styled(Image)`
  position: absolute;
  top: 0;

  img {
    width: 100%;
    height: 100%;
  }
`;
const StyledProductCarousel = styled(ProductCarousel)`
  padding: 12px;
`;
const StyledBlockHeader = styled(BlockHeader)`
  border-bottom: 1px solid ${(props) => props.borderColor};
  .title {
    padding: 0 8px;
  }
`;

export { ProductCarouselWithHeader };
